// extracted by mini-css-extract-plugin
export default {"container":"End_container__3fjq7","won":"End_won__YeFMF","again":"End_again__yj3ZC"};